import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileStickyBar from "../components/MobileStickyBar";
import Seo from "../components/Seo";
import QuoteForm from "../components/QuoteForm";
import { useLang } from "../i18n/LanguageContext";
import { COMPANY } from "../lib/site";

export default function Quote() {
  const { t } = useLang();
  return (
    <div className="min-h-screen">
      <Seo title={`${t("nav.quote")} | ${COMPANY.name}`} description={t("quote.longSubtitle")} path="/be-om-pristilbud" />
      <Header />
      <section className="section">
        <div className="container-page max-w-3xl">
          <span className="eyebrow">{t("nav.quote")}</span>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold">{t("quote.title")}</h1>
          <div className="dot-divider mt-4" />
          <p className="mt-5 text-[#383E45] leading-relaxed">{t("quote.longSubtitle")}</p>
          <div className="mt-8 bg-white border border-[#E2DDD5] rounded-2xl p-6 sm:p-8"><QuoteForm /></div>
        </div>
      </section>
      <Footer /><MobileStickyBar />
    </div>
  );
}
